import * as React from "react";

function Copy(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" {...props}>
      <path
        d="M16 13.4v4.2c0 3.5-1.4 4.9-4.9 4.9H6.9c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"
        stroke={props.color||"var(--color-blue-500)"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 7.4v4.2c0 3.5-1.4 4.9-4.9 4.9H16v-3.1c0-3.5-1.4-4.9-4.9-4.9H8V7.4c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"
        stroke={props.color||"var(--color-blue-500)"}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Copy;
